import {assertAndContinue} from 'Asserts';

import {
  buildPublicLinkFromTagOperation,
  DEFAULT_PUBLIC_API_REFERENCE,
  getTagAndOperationFromSystem,
} from './util';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function getPublicLink(operationPath: any, system: any): string {
  const targetMethod = operationPath.get(2);
  const targetPath = operationPath.get(1);

  const tagOperationObj = getTagAndOperationFromSystem(targetMethod, targetPath, system);

  if (tagOperationObj == null) {
    assertAndContinue(false, `Expected valid operation for path ${targetPath} with method ${targetMethod}`);
    return DEFAULT_PUBLIC_API_REFERENCE;
  }

  return buildPublicLinkFromTagOperation(tagOperationObj);
}
